"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_toastify_1 = require("react-toastify");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const translation_1 = require("../../../common/js/helper/translation");
const _variables_scss_1 = __importDefault(require("../../../scss/_variables.scss"));
const Paths_1 = require("../../constants/Paths");
const history_1 = require("../../helper/history");
const payment_1 = require("../../helper/payment");
const AdyenCheckoutStore_1 = __importDefault(require("../../stores/AdyenCheckoutStore"));
const AdyenPaymentDetailsStore_1 = __importDefault(require("../../stores/AdyenPaymentDetailsStore"));
const AdyenPaymentStatusStore_1 = __importDefault(require("../../stores/AdyenPaymentStatusStore"));
const ShopwareOrder_1 = __importDefault(require("../../stores/ShopwareOrder"));
const ShopwarePaymentMethods_1 = __importDefault(require("../../stores/ShopwarePaymentMethods"));
const ShopCheckoutLayout_1 = __importDefault(require("../ShopCheckoutLayout"));
const ShopCheckoutPaySummary_1 = __importDefault(require("./ShopCheckoutPaySummary"));
class ShopCheckoutPay extends react_1.default.Component {
    paymentContainerRef = react_1.default.createRef();
    contentRef = react_1.default.createRef();
    adyenComponents = [];
    promise = Promise.resolve();
    adyenFormComponent = null;
    adyenFormIsThreeDS2 = false;
    adyenFromIsValid = false;
    redirectUrl = null;
    checkout = null;
    submitting = false;
    loading = false;
    order = null;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            adyenFormComponent: mobx_1.observable,
            adyenFormIsThreeDS2: mobx_1.observable,
            adyenFromIsValid: mobx_1.observable,
            loading: mobx_1.observable,
            onAdyenFormDataChange: mobx_1.action.bound,
            onPay: mobx_1.action.bound,
            order: mobx_1.observable,
            orderId: mobx_1.computed,
            submitting: mobx_1.observable,
        });
    }
    get orderId() {
        return this.props.match?.params?.orderId ?? null;
    }
    get adyenClientKey() {
        return this.order?.extensions?.zkpAdyenData?.clientKey ?? null;
    }
    componentDidMount() {
        this.loadAdyenCheckout();
    }
    componentDidUpdate(prevProps) {
        if (this.orderId !== prevProps.match?.params?.orderId) {
            (0, mobx_1.runInAction)(() => {
                this.order = null;
                this.adyenFormIsThreeDS2 = false;
                this.checkout = null;
            });
            this.loadAdyenCheckout();
        }
    }
    componentWillUnmount() {
        this.adyenComponents.forEach((adyenComponent) => {
            if (adyenComponent && adyenComponent.unmount) {
                adyenComponent.unmount();
            }
        });
        this.adyenComponents = [];
        this.paymentContainerRef = react_1.default.createRef();
        this.contentRef = react_1.default.createRef();
    }
    render() {
        return (react_1.default.createElement(ShopCheckoutLayout_1.default, { title: (0, translation_1.t)('shop_checkout_pay_page.page_title'), loading: this.loading, showSidebarMobile: true, summaryElement: react_1.default.createElement(ShopCheckoutPaySummary_1.default, { loading: this.loading, order: this.order }), submitElement: this.adyenFormIsThreeDS2 ? null : (react_1.default.createElement(Button_1.default, { className: "znd-shop-checkout-summary__submit", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('shop_checkout_pay_page.submit'), onClick: () => {
                    this.adyenFormComponent?.submit();
                }, loading: this.submitting, disabled: this.adyenFormIsThreeDS2 ||
                    !this.adyenFormComponent ||
                    !this.adyenFromIsValid ||
                    this.submitting })) },
            this.loading ? (react_1.default.createElement("div", { className: "znd-shop-checkout-pay-content__loader" },
                react_1.default.createElement(LoadingSpinner_1.default, null))) : null,
            react_1.default.createElement("div", { ref: this.paymentContainerRef, className: "mx-auto znd-shop-checkout-pay-content__adyen" })));
    }
    onAdditionalDetails(state) {
        const orderId = this.orderId;
        if (!orderId) {
            return this.redirectToCart();
        }
        this.promise = this.promise
            .then(() => (this.loading = true))
            .then(this.getCheckout)
            .then((createdCheckout) => {
            const checkout = createdCheckout;
            const ref = this.paymentContainerRef?.current;
            const redirectUrl = this.redirectUrl;
            if (!checkout || !ref || !orderId || !redirectUrl) {
                react_toastify_1.toast.error((0, translation_1.t)('payment_errors.cannot_be_paid'));
                this.redirectToCart();
                return;
            }
            const data = JSON.stringify(state.data);
            return AdyenPaymentDetailsStore_1.default.savePaymentDetails(orderId, data).then((details) => ShopwareOrder_1.default.loadOrder(orderId).then((order) => {
                if (!order) {
                    react_toastify_1.toast.error((0, translation_1.t)('payment_errors.unknown_status'));
                    return this.redirectToCart();
                }
                if (!details) {
                    react_toastify_1.toast.error((0, translation_1.t)('payment_errors.cannot_be_paid'));
                    return this.redirectToPayError(order);
                }
                if (details.isFinal) {
                    window.location.replace(redirectUrl);
                    return;
                }
                if (!details.action) {
                    react_toastify_1.toast.error((0, translation_1.t)('payment_errors.cannot_be_paid'));
                    return this.redirectToPayError(order);
                }
                this.loading = false;
                this.handleThreeDS2FormStylingChanges(details);
                const adyenComponent = checkout
                    .createFromAction(details.action, {
                    onAdditionalDetails: this.onAdditionalDetails,
                    ...this.getThreeDS2ActionOptions(details),
                })
                    ?.mount(ref);
                if (!!adyenComponent) {
                    this.adyenComponents.push(adyenComponent);
                }
            }));
        })
            .finally(() => (this.loading = false));
    }
    loadAdyenCheckout() {
        this.loading = true;
        const orderId = this.orderId;
        if (!orderId) {
            react_toastify_1.toast.error((0, translation_1.t)('payment_errors.canceled_or_paid'));
            this.redirectToCart();
            return;
        }
        ShopwarePaymentMethods_1.default.loadPaymentMethods()
            .then(() => ShopwareOrder_1.default.loadOrder(orderId))
            .then((order) => {
            if (!order) {
                react_toastify_1.toast.error((0, translation_1.t)('payment_errors.no_order'));
                this.redirectToCart();
                return;
            }
            if ((0, payment_1.isOrderPaymentPaid)(order)) {
                this.redirectToConfirmation(order);
                return;
            }
            this.order = order;
            return this.getCheckout().then((createdCheckout) => {
                const checkout = createdCheckout;
                const ref = this.paymentContainerRef?.current;
                if (!checkout || !ref) {
                    react_toastify_1.toast.error((0, translation_1.t)('payment_errors.cannot_be_paid'));
                    this.redirectToPayError(order);
                    return;
                }
                if ((0, payment_1.isOrderPaymentOpen)(order)) {
                    const orderPaymentMethod = (0, payment_1.getCurrentOrderPaymentMethod)(order);
                    const paymentMethod = !!orderPaymentMethod?.id
                        ? ShopwarePaymentMethods_1.default.paymentMethods.find((current) => current.id === orderPaymentMethod.id)
                        : null;
                    this.renderInitialPaymentForm(checkout, paymentMethod?.extensions?.adyenData, ref);
                    return;
                }
                this.loading = false;
                AdyenPaymentStatusStore_1.default.loadPaymentStatus(orderId).then((paymentStatus) => {
                    // If the initial payment status is 3DS, then the payment cannot be recovered.
                    // Adyen will fail with an exception.
                    // This should not happen except if a user refreshes the payment page during 3DS2 payment.
                    if (this.isThreeDS2Action(paymentStatus)) {
                        react_toastify_1.toast.error((0, translation_1.t)('payment_errors.cannot_be_paid'));
                        this.redirectToCart();
                        return;
                    }
                    this.handleThreeDS2FormStylingChanges(paymentStatus);
                    const adyenComponent = checkout
                        .createFromAction(paymentStatus.action, {
                        onAdditionalDetails: this.onAdditionalDetails,
                        ...this.getThreeDS2ActionOptions(paymentStatus),
                    })
                        ?.mount(ref);
                    if (adyenComponent) {
                        this.adyenComponents.push(adyenComponent);
                    }
                });
            });
        })
            .finally(() => {
            this.loading = false;
        });
    }
    renderInitialPaymentForm(checkout, paymentMethodAdyenData, ref) {
        if (!paymentMethodAdyenData || !paymentMethodAdyenData.type || !paymentMethodAdyenData.paymentMethodConfig) {
            react_toastify_1.toast.error((0, translation_1.t)('payment_errors.no_order'));
            this.redirectToCart();
            return;
        }
        const adyenComponent = checkout
            ?.create(paymentMethodAdyenData.type, {
            ...paymentMethodAdyenData.paymentMethodConfig,
            enableStoreDetails: false,
            hasHolderName: true,
            holderNameRequired: true,
            onChange: this.onAdyenFormDataChange,
            onSubmit: this.onPay,
            showPayButton: false,
            styles: {
                base: {
                    color: _variables_scss_1.default.input_color,
                    fontSize: _variables_scss_1.default.font_size_base,
                    fontFamily: _variables_scss_1.default.font_family_base,
                    caretColor: _variables_scss_1.default.input_color,
                },
                error: {
                    color: _variables_scss_1.default.danger_color,
                },
                placeholder: {
                    color: _variables_scss_1.default.input_placeholder_color,
                },
                validated: {
                    color: _variables_scss_1.default.input_color,
                },
            },
        })
            ?.mount(ref);
        if (adyenComponent) {
            this.adyenFormComponent = adyenComponent;
            this.adyenComponents.push(adyenComponent);
        }
    }
    onAdyenFormDataChange(state) {
        this.adyenFromIsValid = !!state?.isValid && !!state?.data;
    }
    onPay(state) {
        const orderId = this.orderId;
        if (!orderId || !state?.isValid || !state?.data) {
            return Promise.reject();
        }
        this.submitting = true;
        // Shopware plugin currently uses "origin" from "additionalData",
        // see https://github.com/Adyen/adyen-shopware6/issues/404
        // TODO: Remove once this has been fixed.
        state.data = {
            ...state.data,
            additionalData: {
                ...(state.data.additionalData ?? {}),
                origin: state.data.origin ?? state.data?.additionalData?.origin ?? undefined,
            },
        };
        const stateData = JSON.stringify(state.data);
        return ShopwareOrder_1.default.handlePayment(orderId, stateData).then((url) => {
            this.redirectUrl = url;
            return AdyenPaymentStatusStore_1.default.loadPaymentStatus(orderId)
                .finally((0, mobx_1.action)(() => {
                this.submitting = false;
            }))
                .then((paymentStatus) => {
                if (paymentStatus.isFinal) {
                    window.location.replace(url);
                    return;
                }
                this.adyenFormComponent = null;
                return this.getCheckout().then((createdCheckout) => {
                    const checkout = createdCheckout;
                    const ref = this.paymentContainerRef?.current;
                    if (!checkout || !ref) {
                        window.location.replace(url);
                        return;
                    }
                    this.handleThreeDS2FormStylingChanges(paymentStatus);
                    const adyenComponent = checkout
                        .createFromAction(paymentStatus.action, {
                        onAdditionalDetails: this.onAdditionalDetails,
                        ...this.getThreeDS2ActionOptions(paymentStatus),
                    })
                        ?.mount(ref);
                    if (adyenComponent) {
                        this.adyenComponents.push(adyenComponent);
                    }
                });
            });
        });
    }
    isThreeDS2Action(paymentInfo) {
        return paymentInfo?.action?.type === 'threeDS2';
    }
    getThreeDS2ActionOptions(paymentInfo) {
        if (this.isThreeDS2Action(paymentInfo)) {
            return { challengeWindowSize: '05' };
        }
        return {};
    }
    handleThreeDS2FormStylingChanges(paymentInfo) {
        const ref = this.paymentContainerRef?.current;
        if (!ref) {
            return;
        }
        (0, mobx_1.runInAction)(() => {
            this.adyenFormIsThreeDS2 = this.isThreeDS2Action(paymentInfo);
            if (this.adyenFormIsThreeDS2) {
                ref.classList.add('znd-shop-checkout-pay-content__adyen--three-ds2');
            }
            else {
                ref.classList.remove('znd-shop-checkout-pay-content__adyen--three-ds2');
            }
        });
    }
    redirectToCart() {
        (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CART);
    }
    redirectToPayError(order) {
        (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT_PAY_ERROR.replace(':orderId', order.id));
    }
    redirectToConfirmation(order) {
        (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT_CONFIRMATION.replace(':orderId', order.id));
    }
    getCheckout() {
        return this.checkout
            ? Promise.resolve(this.checkout)
            : AdyenCheckoutStore_1.default.create(this.adyenClientKey).then((checkout) => {
                if (!checkout) {
                    return Promise.reject();
                }
                this.checkout = checkout;
                return checkout;
            });
    }
}
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "onAdditionalDetails", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "loadAdyenCheckout", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "isThreeDS2Action", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "getThreeDS2ActionOptions", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "redirectToCart", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "redirectToPayError", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "redirectToConfirmation", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPay.prototype, "getCheckout", null);
exports.default = (0, mobx_react_1.observer)(ShopCheckoutPay);
